import { render, staticRenderFns } from "./PstSettings.vue?vue&type=template&id=2210ded4&scoped=true&"
import script from "./PstSettings.vue?vue&type=script&lang=ts&"
export * from "./PstSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PstSettings.vue?vue&type=style&index=0&id=2210ded4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210ded4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
